import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DoctorRevenue from "../components/DoctorRevenue";

const DoctorRevenuePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Doctor's Revenue" />

       <DoctorRevenue />
      </MasterLayout>
    </>
  );
};

export default DoctorRevenuePage;
